"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var phone_utils_1 = require("../../utils/phone-utils");
var StrictPhoneInputControl = function (_a) {
    var _b;
    var onChange = _a.onChange, onExtensionChange = _a.onExtensionChange, defaultCountryCode = _a.defaultCountryCode, countryCodeValue = _a.countryCodeValue, value = _a.value, rest = __rest(_a, ["onChange", "onExtensionChange", "defaultCountryCode", "countryCodeValue", "value"]);
    var containerRef = (0, react_1.useRef)(null);
    var currentCountryRef = (0, react_1.useRef)(((_b = countryCodeValue !== null && countryCodeValue !== void 0 ? countryCodeValue : defaultCountryCode) !== null && _b !== void 0 ? _b : "NA"));
    (0, react_1.useEffect)(function () {
        if (countryCodeValue) {
            currentCountryRef.current = countryCodeValue;
        }
    }, [countryCodeValue]);
    (0, react_1.useEffect)(function () {
        if (!countryCodeValue && defaultCountryCode) {
            currentCountryRef.current = defaultCountryCode;
        }
    }, [defaultCountryCode, countryCodeValue]);
    var handleExtensionChange = (0, react_1.useCallback)(function (extension, countryCode) {
        currentCountryRef.current = countryCode;
        onExtensionChange === null || onExtensionChange === void 0 ? void 0 : onExtensionChange(extension, countryCode);
    }, [onExtensionChange]);
    var handleChange = (0, react_1.useCallback)(function (rawValue) {
        var trimmed = (0, phone_utils_1.enforcePhoneNumberLength)(rawValue, currentCountryRef.current);
        onChange === null || onChange === void 0 ? void 0 : onChange(trimmed);
    }, [onChange]);
    (0, react_1.useEffect)(function () {
        var container = containerRef.current;
        if (!container)
            return;
        var input = container.querySelector('input[type="tel"]');
        if (!input)
            return;
        var handleNativeInput = function (event) {
            var target = event.target;
            if (!target)
                return;
            var trimmed = (0, phone_utils_1.enforcePhoneNumberLength)(target.value, currentCountryRef.current);
            if (trimmed !== target.value) {
                var cursorPosition = trimmed.length;
                target.value = trimmed;
                target.setSelectionRange(cursorPosition, cursorPosition);
            }
        };
        input.addEventListener("input", handleNativeInput, true);
        return function () {
            input.removeEventListener("input", handleNativeInput, true);
        };
    }, [value, countryCodeValue]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: containerRef, children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.PhoneInputControl, __assign({}, rest, { value: value, defaultCountryCode: defaultCountryCode, countryCodeValue: countryCodeValue, onChange: handleChange, onExtensionChange: handleExtensionChange })) }));
};
exports.default = StrictPhoneInputControl;
